module.exports = __webpack_public_path__ + "img/bonus_pc_yn.ded133b2.png";